import { FC, useState, useEffect } from 'react';
import { RsNumberInput, RsInputSize } from 'components/Rsuite/Input';

interface RsBlurNumberInputProps {
  num: number;
  onChange: (v: number) => void;
  size?: RsInputSize;
}

export const BlurNumberInput: FC<RsBlurNumberInputProps> = ({
  num,
  onChange,
  size,
}) => {
  const [tempValue, setTempValue] = useState('');

  useEffect(() => {
    setTempValue(num.toString());
  }, [num]);

  return (
    <RsNumberInput
      num={tempValue}
      size={size}
      onChange={setTempValue}
      onBlur={() => {
        onChange(Number(tempValue));
      }}
    />
  );
};
